import { ActionCardModel } from '@playbooks/action-cards-utils/src'
import { WidgetData } from '@playbooks/core/src/interfaces/ActionCard'

import ActionCardReplacementsProcessor from '../webPlayTitleReplacementsProcessors/ActionCardReplacementsProcessor'
import StaticReplacementsProcessor from '../webPlayTitleReplacementsProcessors/StaticReplacementsProcessor'

export default class RedirectLinkReplacementProcessor {
  actionCardModel: ActionCardModel
  acReplacementProcessor: ActionCardReplacementsProcessor
  staticReplacementProcessor: StaticReplacementsProcessor

  constructor(actionCardModel: ActionCardModel, playTerm: string, senderEmail: string) {
    this.actionCardModel = actionCardModel
    this.acReplacementProcessor = new ActionCardReplacementsProcessor(this.actionCardModel)
    this.staticReplacementProcessor = new StaticReplacementsProcessor(playTerm, senderEmail)
  }

  process(template: string) {
    const [urlTemplate, paramsTemplate] = (template || '').split('?')
    const widgets = [...this.actionCardModel.getSearchService()].flatMap(
      x => (x.data as { widgets: WidgetData[] }).widgets || [],
    )
    const url = processReplacements.call(this, widgets, urlTemplate)
    const params = new URLSearchParams(paramsTemplate)

    params.keys().forEach(key => {
      params.set(key, processReplacements.call(this, widgets, params.get(key) || ''))
    })

    return `${url}?${params.toString()}`
  }
}

function processReplacements(this: RedirectLinkReplacementProcessor, widgets: WidgetData[], template: string) {
  if (!template) return ''

  let result = this.acReplacementProcessor.process(template)
  result = this.staticReplacementProcessor.process(result)

  for (const widget of widgets) {
    // Case of if a widget has code and value properties
    const widgetWithCodeAndValue = widget as WidgetData & { code: string; value: string }
    const { code, value } = widgetWithCodeAndValue

    if (code) {
      result = result.replaceAll(`$${code}`, value || '')
    }
  }

  return result
}
